export default __webpack_public_path__ + "static/media/2307.83a6940a.png";